import {
  CREATE_SIGNUP,
  CREATE_SIGNUP_SUCCESS,
  CREATE_SIGNUP_ERROR,
  CREATE_SIGNUP_CLEAR_DATA
} from '../actions';

export const createSignup = (signup, history, isRightPanel = false, activityInfo) => ({
  type: CREATE_SIGNUP,
  payload: { signup, history, isRightPanel, activityInfo }
});

export const createSignupSuccess = () => ({
  type: CREATE_SIGNUP_SUCCESS,
  payload: {}
});

export const createSignupError = (message) => ({
  type: CREATE_SIGNUP_ERROR,
  payload: { message }
});

export const clearSignupData = () => ({
  type: CREATE_SIGNUP_CLEAR_DATA,
  payload: {}
});
